// extracted by mini-css-extract-plugin
module.exports = {"topbar":"style_topbar__MX9R6","info":"style_info__v-n3M","brand":"style_brand__2i7tW"};